let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gxPuD")).then(() => parcelRequire('ceVmw'));